import { List, TextField, EditButton, SimpleList, Datagrid, TopToolbar, CreateButton } from "react-admin";
import { EmptyList } from "server/components";
import { useMediaQuery } from "@mui/material";
import { settings } from "app";
import { MOBILE_BREAKPOINT } from "utils/constants";
import { EmailGroupsExporter } from "./XlsxExporter";
import { ExportXlsButton } from "features/ExportXlsxButton";
import { MobileListRow } from "features/MobileListRow";

const ListEmailGroups = () => {
  const isMobile = useMediaQuery(MOBILE_BREAKPOINT);
  const ListActions = (hasCreate) => {
    return (
      <TopToolbar>
        { hasCreate && <CreateButton/> } 
        <ExportXlsButton exporter={EmailGroupsExporter}/>
      </TopToolbar>
    )
  }

  return (
    <List
      actions={<ListActions hasCreate={true}/>}
      title="Email Groups"
      sx={settings.style.expandStyle}
    >
      {isMobile ? (
        <SimpleList
          empty={<EmptyList />}
          linkType={false}
          sx={settings.style.mobileList}
          primaryText={record => (
            <MobileListRow
              fields={[
                { label: "Име на групата", value: record.name },
                { label: "Описание", value: record.description },
              ]}
            />
          )}
          tertiaryText={record => (
            <>
              <EditButton label="" />
            </>
          )}
        />
      ) : (
        <Datagrid
          bulkActionButtons={false}
          rowClick={false}
        >
          <TextField
            source="name"
            label="Име на групата"
            sortable={false}
          />
          <TextField
            source="description"
            label="Описание"
            sortable={false}
          />
          <EditButton />
        </Datagrid>
      )}
    </List>
  );
};
export default ListEmailGroups;
